import { toDate, getAgeFromDate } from '@/js/validators/utils';
/**
 * Compares the selected date if earlier or beyond from the date provided
 */
// Fichier pour toute manipulation de date
const dateCompare = ({ value, compare, validationType }) => {
  let pass = true;

  if (toDate(value) instanceof Date && toDate(compare) instanceof Date) {
    const valueDate = toDate(value);
    const compDate = toDate(compare);

    pass = validateDate(valueDate, compDate, validationType);
  }

  if (Array.isArray(value) && toDate(compare) instanceof Date) {
    const compDate = toDate(compare);

    for (let i = 0; i < value.length; i++) {
      const valueDate = toDate(value[i]);

      pass = validateDate(valueDate, compDate, validationType);

      if (!pass) return pass;
    }
  }

  if (Array.isArray(compare) && toDate(value) instanceof Date) {
    const valueDate = toDate(value);

    for (let i = 0; i < compare.length; i++) {
      const compDate = toDate(compare[i]);

      pass = validateDate(valueDate, compDate, validationType);

      if (!pass) return pass;
    }
  }

  return pass;
};

const getAge = (date, addDays = 0) => {
  return getAgeFromDate(date, addDays);
};

const validateDate = (value, compare, validationType) => {
  let pass = true;

  if (validationType === 'earlier') {
    pass = isEarlier(value, compare);
  }

  if (validationType === 'beyond') {
    pass = isBeyond(value, compare);
  }

  return pass;
};

const isEarlier = (value, compare) => {
  return !(value < compare);
};

const isBeyond = (value, compare) => {
  return !(value > compare);
};

export { dateCompare, getAge };
